var render = function render(){var _vm=this,_c=_vm._self._c;return _c('landing-page-template',[_c('landing-contact',{attrs:{"id":"contact","isMobile":_vm.isMobile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }